module.exports = __webpack_public_path__ + "static/media/publicsonar_crowdcontrol_hover.d3a0531f.svg";